import React from 'react';
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';

const ServiceInvoiceHistory = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <p className="text-sm text-text-muted py-4">
                No invoice history available yet.
            </p>
        );
    }

    const formatMonth = (month) => {
        const [year, m] = month.split('-');
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return `${months[parseInt(m, 10) - 1]} '${year.slice(2)}`;
    };

    return (
        <div className="h-[200px] w-full">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--surface-border, #e5e7eb)" />
                    <XAxis
                        dataKey="month"
                        tickFormatter={formatMonth}
                        tick={{ fontSize: 12, fill: 'var(--text-muted, #6b7280)' }}
                        stroke="var(--surface-border, #e5e7eb)"
                    />
                    <YAxis
                        tick={{ fontSize: 12, fill: 'var(--text-muted, #6b7280)' }}
                        stroke="var(--surface-border, #e5e7eb)"
                        tickFormatter={(value) => `$${value}`}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'var(--surface-raised, #ffffff)',
                            border: '1px solid var(--surface-border, #e5e7eb)',
                            borderRadius: '8px',
                            fontSize: '13px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        }}
                        labelFormatter={(label) => `Month: ${label}`}
                        formatter={(value) => [`$${Number(value).toFixed(2)}`, 'Total Amount']}
                    />
                    <Line
                        type="monotone"
                        dataKey="total_amount"
                        stroke="var(--accent, #3b82f6)"
                        strokeWidth={2}
                        dot={{ fill: 'var(--accent, #3b82f6)', r: 3 }}
                        activeDot={{ r: 5 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ServiceInvoiceHistory;
